import { ClientName } from 'src/app/shared/model/query-body.model';
import {
  AnswerType,
  Configuration,
} from '../configurations.model';

export const SK_GPT: Configuration = {
  title: ClientName.SK,
  shortName: ClientName.SK,
  logoFileName: 'sk-logo-white.svg',
  searchSettings: {
    answerType: AnswerType.LFGA,
    retriever_number: 6,
    temperature: 0,
  },
  examples: [
    {
      language: 'english',
      flagClass: 'us',
      questions: [
        'What is Smart-ID used for?',
        'Can I give a digital signature with Smart-ID?',
        'How much does it cost to use Smart-ID?',
        'How long is a Smart-ID account valid?',
        'I have Mobile-ID – why would I need Smart-ID?',
]
    },
    {
      language: 'estonian',
      flagClass: 'ee',
      questions: [
        'Milleks Smart-ID-d kasutatakse?',
        'Kas ma saan Smart-IDga digiallkirja anda?',
        'Kui palju maksab Smart-ID kasutamine?',
        'Kui kaua kehtib Smart-ID konto?',
        'Mul on Mobiil-ID – milleks mulle Smart-ID?',
      ]
    },
  ]
};
